import { AfterViewInit, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'screen-cell-custom,screen-cell[custom]',
  templateUrl: './cell.custom.component.html',
  styleUrls: ['./cell.custom.component.less']
})
export class CellCustomComponent implements AfterViewInit {

  constructor(private _elementRef: ElementRef) {
  }

  ngAfterViewInit() {

  }

}
